import { css, html } from 'react-strict-dom';
import { Style } from 'src/constants';
import { color } from 'src/constants/color.css';

import Text from './Text';

type Props = {
  label: string | React.ReactNode;
  checked: boolean;
  onChange: (checked: boolean) => void;
};

export default function Checkbox({ label, checked, onChange }: Props) {
  return (
    <html.button
      style={[Style.row, Style.alignCenter, styles.container]}
      onClick={() => onChange(!checked)}
    >
      <html.div
        style={[
          Style.row,
          Style.centerBoth,
          styles.box,
          checked && styles.boxChecked,
        ]}
      >
        {checked && (
          <i className="fa-solid fa-check" style={{ fontSize: 12 }} />
        )}
      </html.div>
      {typeof label === 'string' ? (
        <Text typeface="body.medium" color="neutral100">
          {label}
        </Text>
      ) : (
        label
      )}
    </html.button>
  );
}

const styles = css.create({
  container: {
    // A label long enough to wrap must stay left-aligned beside the box, not
    // inherit the button's centred text.
    alignItems: 'flex-start',
    textAlign: 'left',
    gap: 6,
    paddingInline: 0,
    paddingBlock: 4,
    borderWidth: 0,
    backgroundColor: 'transparent',
    cursor: 'pointer',
  },
  box: {
    width: 20,
    height: 20,
    borderRadius: 4,
    borderWidth: 2,
    borderStyle: 'solid',
    borderColor: color.neutral40,
    backgroundColor: '#fff',
    flexShrink: 0,
  },
  boxChecked: {
    borderWidth: 0,
    backgroundColor: color.accent,
    color: '#fff',
  },
});
